import { UniversalSelectWithRHF } from 'components/common/Select/UniversalSelectWithRHF';
import { useIsSupplierPortalProductEditorFieldDisabled } from 'hooks/useUserState_utils';
import { useTranslation } from 'react-i18next';

export const TechnologyField: React.FC = () => {
  const { t } = useTranslation();
  const disabled = useIsSupplierPortalProductEditorFieldDisabled();
  return (
    <UniversalSelectWithRHF
      // We can't send a segment here, because otherwise the dictionary will be empty
      // Read this for more: https://docs.google.com/spreadsheets/d/1vsqtpZAoP2TejqueyDmWbI0W2Sq5tumSar7jiRhEoA4/edit#gid=3788796
      type="TECHNOLOGY" // should be UX_BEAUTY_TECHNOLOGY to be aligned to other UXB fields
      creatable
      formId="private_attributes.data.technology"
      label={t('forms.product.technology.label')}
      disabled={disabled}
    />
  );
};
